'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var themeUtils = require('./themeUtils-2eefcd1f.js');
require('./enums-de2d9d36.js');

var variantsStyles = {
    master: styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    border-color: ", ";\n  "], ["\n    border-color: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.adminGreyMedium;
    }),
    active: styled.css(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.fontColor;
    }),
};
var variantsVerticalStyles = {
    master: styled.css(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.darkGrey6;
    }),
    active: styled.css(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n    color: ", ";\n    font-weight: 700;\n  "], ["\n    color: ", ";\n    font-weight: 700;\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.primary;
    }),
};
var verticalStyles = styled.css(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n  height: ", ";\n  margin-bottom: ", ";\n  padding: 0 13px 0;\n  font: 18px/22px ", ";\n  border-left: ", ";\n  text-align: left;\n"], ["\n  height: ", ";\n  margin-bottom: ", ";\n  padding: 0 13px 0;\n  font: 18px/22px ", ";\n  border-left: ", ";\n  text-align: left;\n"])), function (_a) {
    var tabSize = _a.tabSize, theme = _a.theme;
    return (themeUtils.isConsumerTheme(theme) ? 'auto' : tabSize + "px");
}, function (_a) {
    var verticalTabBottomMargin = _a.verticalTabBottomMargin;
    return verticalTabBottomMargin + "px";
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme, lineWidth = _a.lineWidth;
    return lineWidth + "px solid " + theme.colors.universal.transparent;
});
var horizontalStyles = styled.css(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject(["\n  width: ", ";\n  padding: ", ";\n  font: 14px/22px ", ";\n  border-bottom: ", ";\n"], ["\n  width: ", ";\n  padding: ", ";\n  font: 14px/22px ", ";\n  border-bottom: ",
    ";\n"])), function (_a) {
    var tabSize = _a.tabSize, theme = _a.theme;
    return (themeUtils.isConsumerTheme(theme) ? 'auto' : tabSize + "px");
}, function (_a) {
    var theme = _a.theme;
    return (themeUtils.isConsumerTheme(theme) ? '0 10px 2px' : '0 0 2px');
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme, lineWidth = _a.lineWidth;
    return lineWidth + "px solid " + theme.colors.greys.adminGreyMedium;
});
var iconStyles = styled.css(templateObject_7 || (templateObject_7 = tslib_es6.__makeTemplateObject(["\n  width: auto;\n  height: auto;\n  padding: 4px 8px 20px;\n  font: 14px/22px ", ";\n  background-color: ", ";\n  margin-right: 17px;\n  color: ", ";\n  font-weight: ", ";\n  display: flex;\n  align-items: center;\n  border-left: 0;\n  border-bottom: ", ";\n  ", ";\n\n  .tab-icon {\n    display: inline-flex;\n    margin-right: 8px;\n\n    & svg {\n      color:\n        ", ";\n    }\n  }\n\n  &:hover, &:focus {\n    color: ", ";;\n    font-weight: 500;\n  }\n"], ["\n  width: auto;\n  height: auto;\n  padding: 4px 8px 20px;\n  font: 14px/22px ", ";\n  background-color: ", ";\n  margin-right: 17px;\n  color: ", ";\n  font-weight: ", ";\n  display: flex;\n  align-items: center;\n  border-left: 0;\n  border-bottom: ", ";\n  ", ";\n\n  .tab-icon {\n    display: inline-flex;\n    margin-right: 8px;\n\n    & svg {\n      color:\n        ", ";\n    }\n  }\n\n  &:hover, &:focus {\n    color: ", ";;\n    font-weight: 500;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyLight;
}, function (_a) {
    var theme = _a.theme, variant = _a.variant;
    return (variant === 'active' ? theme.colors.primary : theme.colors.greys.adminGreyDark);
}, function (_a) {
    var variant = _a.variant;
    return (variant === 'active' ? '500' : '400');
}, function (_a) {
    var theme = _a.theme, lineWidth = _a.lineWidth;
    return lineWidth + "px solid " + theme.colors.greys.adminGreyMedium;
}, function (_a) {
    var theme = _a.theme, variant = _a.variant;
    return (variant === 'active' && "border-color: " + theme.colors.primary);
}, function (_a) {
    var theme = _a.theme, variant = _a.variant;
    return (variant === 'active' ? theme.colors.primary : theme.colors.greys.adminGreyDark);
}, function (_a) {
    var theme = _a.theme, variant = _a.variant;
    return (variant === 'active' ? theme.colors.primary : theme.colors.greys.adminGreyDark);
});
var orientationsStyles = {
    vertical: verticalStyles,
    horizontal: horizontalStyles,
};
var StyledTab = styled__default.button(templateObject_8 || (templateObject_8 = tslib_es6.__makeTemplateObject(["\n  border: 0;\n  ", ";\n  color: ", ";\n  background-color: ", ";\n  cursor: pointer;\n  border-color: ", ";\n  transition: .3s;\n\n  ", ";\n  ", "\n\n  &:hover, &:focus{\n    ", ";\n    font-weight: ", ";\n  }\n  &:focus{\n    outline: none;\n  }\n\n  ", ";\n"], ["\n  border: 0;\n  ", ";\n  color: ", ";\n  background-color: ", ";\n  cursor: pointer;\n  border-color: ",
    ";\n  transition: .3s;\n\n  ",
    ";\n  ",
    "\n\n  &:hover, &:focus{\n    ",
    ";\n    font-weight: ", ";\n  }\n  &:focus{\n    outline: none;\n  }\n\n  ", ";\n"])), function (_a) {
    var _b = _a.orientation, orientation = _b === void 0 ? 'horizontal' : _b;
    return orientationsStyles[orientation];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyDark;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.universal.transparent;
}, function (_a) {
    var variant = _a.variant, theme = _a.theme, disabled = _a.disabled;
    return themeUtils.isConsumerTheme(theme) && !disabled && variant === 'active' && theme.colors.primary;
}, function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'master' : _b, _c = _a.orientation, orientation = _c === void 0 ? 'horizontal' : _c;
    return (orientation === 'vertical' ? variantsVerticalStyles[variant] : variantsStyles[variant]);
}, function (_a) {
    var disabled = _a.disabled;
    return disabled && "\n  opacity: .5;\n  cursor: not-allowed;\n  ";
}, function (_a) {
    var theme = _a.theme, variant = _a.variant, disabled = _a.disabled, orientation = _a.orientation;
    if (variant !== 'active' && !disabled && orientation !== 'vertical') {
        return "color: " + theme.colors.fontColor;
    }
    return '';
}, function (_a) {
    var variant = _a.variant, disabled = _a.disabled;
    return variant !== 'active' && !disabled && '700';
}, function (_a) {
    var isIconVariant = _a.isIconVariant;
    return isIconVariant && iconStyles;
});
var Tab = function (_a) {
    var dataTestId = _a.dataTestId, label = _a.label, icon = _a.icon, children = _a.children, _b = _a.lineWidth, lineWidth = _b === void 0 ? 2 : _b, _c = _a.isIconVariant, isIconVariant = _c === void 0 ? false : _c, restTabProps = tslib_es6.__rest(_a, ["dataTestId", "label", "icon", "children", "lineWidth", "isIconVariant"]);
    return (React__default.createElement(StyledTab, tslib_es6.__assign({ type: "button", className: dataTestId && dataTestId, "data-testid": dataTestId && dataTestId, lineWidth: lineWidth, isIconVariant: isIconVariant }, restTabProps),
        icon && React__default.createElement("span", { className: "tab-icon" }, icon),
        (label || children) && React__default.createElement("span", null, label || children)));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;

exports.Tab = Tab;
exports.orientationsStyles = orientationsStyles;
